import { render, staticRenderFns } from "./Parrilla.vue?vue&type=template&id=7cbdde21&scoped=true&"
import script from "./Parrilla.vue?vue&type=script&lang=js&"
export * from "./Parrilla.vue?vue&type=script&lang=js&"
import style0 from "./Parrilla.vue?vue&type=style&index=0&id=7cbdde21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbdde21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem})
